/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:960px){.payment-error[_ngcontent-%COMP%]{margin-bottom:20px}}.payment-error[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#d30000;font-size:80px}.payment-error[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{font-size:30px;color:#d30000;margin-bottom:32px}.payment-error[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:10px}"];
export { styles as styles };
